<template>
  <el-form label-width="90px" class="put_order_form">
    <el-form-item label="投放时间" size="mini">
      <SearchTime v-model="searchTime"></SearchTime>
    </el-form-item>
    <el-form-item class="must custom" label="合同编码">
      <el-input placeholder="请输入正确的合同编码" :maxlength="30" v-model="searchCondition.contractNo" @blur="contractHandle" @keyup.enter.native="contractHandle">
        <i slot="suffix" class="iconfont icon-biaodan-tianxie"></i>
      </el-input>
    </el-form-item>
    <!-- <el-form-item class="must custom" label="展现位置">
      <el-select placeholder="选择展现位置" popper-class="form_pop" v-model="searchCondition.displayRegion">
        <el-option v-for="reg in displayRegions" :key="reg.value" :label="reg.label" :value="reg.value"></el-option>
      </el-select>
    </el-form-item> -->

    <el-button
      type="default"
      plain
      class="btn download_btn"
      icon="iconfont icon-download-template"
      @click="downloadTemplate">
      下载Excel模板
    </el-button>
    <el-upload
      class="upload_btn"
      :headers="upHeaders"
      :show-file-list="false"
      accept=".xlsx"
      name="file"
      :action="config.importExcel"
      :with-credentials="true"
      :before-upload="beforeUpload"
      :on-progress="uploadProgress"
      :on-success="uploadSuccess">
      <el-button type="primary" class="btn import_btn" icon="iconfont icon-shangchuananniu">
        {{importStatus === 2 ? '重新上传Excel文件' : '导入Excel文件' }}
      </el-button>
    </el-upload>
    <span class="txt_sub">仅支持xlsx格式，大小不超过6MB</span>
  </el-form>
</template>

<script>
import SearchTime from './MySearchTime'

export default {
  name: "ImportCondition",
  components: { SearchTime },
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    },
    importStatus: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      fileObj: {
        name: '',
        progress: 0
      },
      searchTime: [],
      searchCondition: {
        contentTime: '',
        startDate: '',
        endDate: '',
        contractNo: '',
        displayRegion: 1
      },
      importResultData: []
    }
  },
  computed: {
    upHeaders () {
      return {
        token: localStorage.getItem('user_ticket') || undefined
      }
    }
  },
  watch: {
    searchTime (o) {
      if (!o || o.length < 2) return
      this.searchCondition.startDate = o[0]
      this.searchCondition.endDate = o[1]
    },
    searchCondition: {
      deep: true,
      handler (nv) {
        this.search()
      }
    },
    importStatus (val) {
      this.$emit('update:importStatus', val)
    }
  },
  methods: {
    async downloadTemplate () {
      await this.$exportGet(this.config.uploadTemplate)
    },
    beforeUpload (file) {
      if (file.size > 6 * 1024 * 1024) {
        this.$message.warning('文件大小超出限制')
        return false
      }
      if (!this.testInput()) return false
      this.fileObj.name = file.name
      this.fileObj.process = 0
      this.$emit('update:importStatus', 1)
    },
    uploadSuccess (response, file, fileList) {
      this.$emit('update:importStatus', 2)
      this.fileObj.name = ''
      this.fileObj.process = 0
      if (response.code === 0) {
        this.importResultData = response.data
        this.search()
      } else {
        this.$message.error(response.message || response.msg)
        this.importResultData = []
      }
    },
    contractHandle() {
      this.searchCondition.contractNo = (this.searchCondition.contractNo || '').trim()
    },
    search () {
      if (!this.testInput()) return
      this.$emit('search', {
        condition: this.searchCondition,
        result: this.importResultData
      })
    },
    testInput () {
      if (!this.searchCondition.contractNo) return this.messageTip('请输入合同编码', 2)
      return true
    },
    uploadProgress (event, file, fileList) {
      this.fileObj.progress = event.percent
      this.$emit('progress', this.fileObj)
    },
  }
}
</script>

<style scoped lang="scss">
.put_order_form {
  margin: 20px;
  .el-form-item {
    margin-bottom: 20px;
    border: 1px solid #E9E9E9;
    border-radius: 4px;
  }
  ::v-deep .el-form-item__label {
    line-height: 20px;
    padding-top: 0;
    padding-bottom: 0;
    margin: 9px 0;
    border-right: 1px solid #E9E9E9;
  }
  .custom.must {
    ::v-deep .el-form-item__label {
      &:before {
        left: 14px;
      }
    }
  }
  ::v-deep .el-form-item__content {
    input {
      border: none;
    }
  }
  .el-input__inner {
    border: none !important;
  }
  .download_btn {
    width: 100%;
    margin-top: 10px;
    color: #FF3973;
    border: 1px solid #FF3973;
    &:hover {
      color: #FF3973;
      border: 1px solid #FF3973;
    }
  }
  .import_btn {
    width: 100%;
    margin-top: 10px;
    margin-left: 0;
    background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%);
    border: none;
    &.is-disabled {
      background: #aaa;
    }
  }
  .upload_btn {
    ::v-deep .el-upload {
      display: block;
    }
  }
  .txt_sub {
    display: block;
    text-align: center;
    margin-top: 10px;
    color: #999;
    font-size: 12px;
    line-height: 17px;
  }
}
</style>
